import React, {useState, useEffect} from "react";
import { CheckCircle, Download } from "lucide-react";
import "./Ordertracking.css"; // Import the external CSS file
import { useLocation } from "react-router-dom";
import { getInvoice } from "../../../Apis/Invoice";


const OrderTracking = () => {

let location = useLocation();
let orderResponse = location?.state?.orderData;

const invoicePayload ={"orderIds": [orderResponse?.data?.lastOrderId]}
console.log("orderResponse", orderResponse);

const [loading, setLoading] = useState(false);
  const trackingSteps = [
    { status: "Order Placed", date: "2024-02-25", completed: true },
    { status: "Shipped", date: "2024-02-26", completed: false },
    { status: "Out for Delivery", date: "2024-02-27", completed: false },
    { status: "Delivered", date: "2024-02-28", completed: false },
  ];


  const fetchInvoice = async () => {
    setLoading(true);
    try {
      const orderData = await getInvoice(invoicePayload);
      console.log("orderData...", orderData);
      let invoiceURL = orderData?.response?.invoice_url;

      if (invoiceURL) {
        window.open(invoiceURL, "_blank"); // Opens in a new tab without reloading
      } else {
        console.error("Invoice URL not found");
      }
      
  } catch (error) {
      console.error("Error fetching products:", error);
      // Swal.fire({
      //   icon: "error",
      //   title: "Error!",
      //   text: "Failed to fetch product list.",
      // });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="order-container">
      {/* Order Confirmation Box */}
      <div className="order-success">Order Successfully Placed!</div>
      <p className="order-details">
        Order ID: <span>{orderResponse?.data?.id}</span>
      </p>
      <p className="order-details">
        Tracking ID: <span>TRKORD1TD45XRK0</span>
      </p>

      {/* Download Invoice Button */}
      <button className="download-button flex items-center justify-center" onClick={fetchInvoice} disabled={loading}>
  {loading ? (
    <svg className="animate-spin h-5 w-5 text-white mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
    </svg>
  ) : (
    <Download size={16} className="mr-2" />
  )}
  {loading ? "Downloading..." : "Download Invoice"}
</button>


      {/* Delivery Details */}
      <div className="delivery-details">
        <h3>Delivery Details</h3>
        <p>Expected Delivery: February 28, 2024</p>
        <p>Shipping Address: 123 Main St, Mumbai, Maharashtra 400001</p>
      </div>

      {/* Tracking Status */}
      <div className="tracking-container">
        <h3 className="tracking-header">Tracking Status</h3>
        {trackingSteps.map((step, index) => (
          <div
            key={index}
            className={`tracking-step ${step.completed ? "active" : ""}`}
          >
            <div className="status-icon"></div>
            <div className="tracking-info">
              <p className="tracking-title">{step.status}</p>
              <p className="tracking-date">{step.date}</p>
              <p className="tracking-description">
                {step.status === "Order Placed"
                  ? "Your order has been confirmed and is being processed."
                  : step.status === "Shipped"
                  ? "Package has been shipped via Express Delivery."
                  : step.status === "Out for Delivery"
                  ? "Package is out for delivery in your area."
                  : "Expected delivery by 7:00 PM."}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderTracking;
